type ClaimBalance = {
  id?: number; status?: string | null; reviewedAt?: string | null;
  crewId?: number | string | null; claimMonth?: string | null;
  balanceCf?: number | null; bfAmount?: number | null;
  wagesEarned?: number | null; deductionsTotal?: number | null;
}

/** Reviewed claim gross already contains its opening balance. */
export function allotmentAvailableBalance(gross: number, opening: number,
  hasReviewedClaim: boolean, claimOpening: number): number {
  return hasReviewedClaim ? gross + opening - claimOpening : opening + gross
}

export function latestReviewedClaim(claims: ClaimBalance[], crewId: number | string, period: string) {
  return claims.filter((claim) => Number(claim.crewId) === Number(crewId)
    && (claim.claimMonth || '').startsWith(period)
    && (claim.status === 'REVIEWED' || Boolean(claim.reviewedAt)))
    .sort((a, b) => Number(b.id || 0) - Number(a.id || 0))[0]
}

/** A stored net balance is never reconstructed from salary alone. */
export function resolveAllotmentCarryForward(row: {
  carryForwardAmount?: number | null; balanceBroughtForward?: number | null;
  allotmentAmount?: number | null; amount?: number | null;
}, claim?: ClaimBalance): number {
  const saved = row.carryForwardAmount
  if (saved == null) return Number(row.balanceBroughtForward ?? 0)
  const allocation = Number(row.allotmentAmount ?? row.amount ?? 0)
  if (!claim || !(claim.status === 'REVIEWED' || claim.reviewedAt) || allocation <= 0) return Number(saved)
  const gross = claim.status === 'REJECTED'
    ? Math.max(0, Number(claim.bfAmount ?? 0) + Number(claim.wagesEarned ?? 0) - Number(claim.deductionsTotal ?? 0))
    : claim.balanceCf
  if (gross != null && Number.isFinite(Number(gross)) && Number(gross) > 0
    && Math.round(Number(saved) * 100) === Math.round(Number(gross) * 100)) {
    return Math.round(Math.max(0, Number(gross) - allocation) * 100) / 100
  }
  return Number(saved)
}

/** Fetch both statement periods; older APIs may only support the all-claims endpoint. */
export async function loadAllotmentClaimsForPeriods<T>(periods: string[],
  loadMonth: (month: string) => Promise<T[]>, loadAll: () => Promise<T[]>): Promise<T[]> {
  try {
    const rows = await Promise.all([...new Set(periods.filter(Boolean))].map((period) => loadMonth(`${period}-01`)))
    return rows.reduce<T[]>((all, month) => all.concat(month), [])
  } catch (error) {
    const status = (error as {response?: {status?: number}})?.response?.status
    if (status === 401 || status === 403) throw error
    return loadAll()
  }
}
